import {forwardRef, useImperativeHandle, useState} from "react";
import useVMStore from "../../store";
import axios from "axios";
import {Modal} from "react-bootstrap";

interface SendMailHandle {
    sendForm: () => void;
}

const SendMail = forwardRef<SendMailHandle, {}>(function SendMail(props, ref) {
    const {data, setCompletedForm} = useVMStore();

    const [sending, setSending] = useState<boolean>(false);

    const [sendingState, setSendingState] = useState<"sending" | "success" | "fail">("sending");

    const url = "https://vmts.ch/wp-json/send-email/v1/send";
    /*const url = window.location.origin + '/test-mail/wp-json/send-email/v1/send';*/

    useImperativeHandle(ref, () => ({
        sendForm() {
            const formData = new FormData();
            const files = data.page13.files;
            if (files.length) {
                for (let i = 0; i < files.length; i++) {
                    formData.append("file[]", files[i]);
                }
            }
            getData();
            setSendingState("sending");
            setSending(true);
            axios
                .post(url, formData)
                .then(function () {
                    /*setSendingState('success');*/
                    setCompletedForm();
                })
                .catch(function (error) {
                    console.log(error);
                    setSendingState("fail");
                });

            function getPage9Template(name: string, isNull: boolean = false) {
                return `
                    <table style='min-width: 100%; max-width: 100%; word-wrap: break-word; word-break: break-word; padding: 5px;'>
                        <tbody>
                        <tr>
                            <td style='min-width: 100%; max-width: 100%; word-wrap: break-word; word-break: break-word;'>
                                <table
                                        style='
                                            min-width: 100%;
                                            max-width: 100%;
                                            word-wrap: break-word;
                                            word-break: break-word;
                                            padding: 10px 28px;
                                            border-radius: 9999px;
                                            border-width: 1px;
                                            border-style: solid;
                                            ${isNull ? "opacity: 0.3" : "border-color: green; color: green"}
                                        '
                                >
                                    <tbody>
                                    <tr>
                                        <td style='min-width: 100%; max-width: 100%; word-wrap: break-word; word-break: break-word; text-align: center'>
                                            ${name.replace("DACH", "Dachgeschoss")}
                                        </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </td>
                        </tr>
                        </tbody>
                    </table>
            `;
            }

            function createFloorTemplate(type: "dach" | "eg" | "ug"): string {
                const num = data.page9[type];
                let template = [getPage9Template((type !== "eg" ? "1. " : "") + type.toUpperCase(), num === 0)];
                if (num > 1) {
                    if (type !== "eg") {
                        for (let i = 2; i < num + 1; i++) {
                            template.push(getPage9Template(i + ". " + type.toUpperCase()));
                        }
                    } else {
                        for (let i = 1; i < num; i++) {
                            template.push(getPage9Template(i + ". OG"));
                        }
                    }
                }
                if (type === "eg") {
                    template.reverse();
                }
                return template.join("");
            }

            function getData() {
                for (const [page, val] of Object.entries(data)) {
                    switch (page) {
                        case "page2": {
                            formData.append("address", val.stradresseDesProjektasse);
                            formData.append("google_address", val.googleAddressLink);
                            break;
                        }
                        case "page3": {
                            formData.append("scope", val);
                            break;
                        }
                        case "page4": {
                            formData.append("cad_type", val);
                            break;
                        }
                        case "page5": {
                            formData.append("cad_soft", val);
                            break;
                        }
                        case "page6": {
                            formData.append("masterplan", val);
                            break;
                        }
                        case "page7": {
                            formData.append("standard", val);
                            break;
                        }
                        case "page8": {
                            formData.append("outside_standard", val);
                            break;
                        }
                        case "page9": {
                            formData.append("floor_dach", createFloorTemplate("dach"));
                            formData.append("floor_eg", createFloorTemplate("eg"));
                            formData.append("floor_ug", createFloorTemplate("ug"));
                            break;
                        }
                        case "page10": {
                            formData.append(
                                "plan_type",
                                val.type +
                                    (typeof val.que !== "string"
                                        ? ""
                                        : `<ul><li>Querschnitte: ${val.que}</li><li>Längsschnitte: ${val.lan}</li>` +
                                          (val.fas ? `<li>Fassadenansichten: ${val.fas}</li></ul>` : "</ul>")),
                            );
                            break;
                        }
                        case "page12": {
                            formData.append("terrain", val);
                            break;
                        }
                        case "page13": {
                            let temp = val.files.length
                                ? val.files.map((f: File) => `<li>${f.name}</li>`).join("")
                                : "...";
                            if (temp) {
                                temp = `<ol>${temp}</ol>`;
                            }
                            formData.append("file_names", temp);
                            break;
                        }
                        case "page14": {
                            formData.append("note", val);
                            break;
                        }
                        case "page15": {
                            debugger;
                            formData.append("vorname", val.vorname);
                            formData.append("nachname", val.nachname);
                            formData.append("email", val.email);
                            formData.append("telefon", val.telefon);
                            formData.append("firma", val.firma || "...");
                            break;
                        }
                    }
                }
            }
        },
    }));

    return (
        <div className="send-mail">
            <Modal
                show={sending}
                onHide={() => {
                    if (sendingState !== "sending") {
                        setSending(false);
                    }
                }}
                centered={true}
            >
                <Modal.Header closeButton={sendingState !== "sending"} />
                <Modal.Body>
                    <div className="w-100 d-flex justify-content-center align-items-center">
                        <img src={`${process.env.REACT_APP_ROOT_DIRECTORY}assets/images/${sendingState}.svg?${Date.now()}`} alt="Detail" className="w-50" />
                    </div>
                </Modal.Body>
            </Modal>
        </div>
    );
});

export default SendMail;
